<div class="step-contrainer" [style.margin-top]="stepDivData?.top   + 'px'"  >
  <div class="step-wrap" 
    #step  
    [class.anitated]=" this.stepDivData?.stepIsCalculated"
    [class.hide-pointer]="hidePointer"
    [style.visibility]=" this.stepDivData?.stepIsCalculated? 'visible' : 'hidden'"
    [style.background]="stepsStylingMap.get(contractStep.target_type).stepViewBackGround" >

    <div class="step-preview-title">
      <div class="step-preview-title-name" (click)="editStepName()">
        <span [ngSwitch]="contractStep.target_type">
          <span *ngSwitchCase="'multi_payment'">
            {{'Раскрытие аккредитива на сумму:'}}
          </span>
          <span *ngSwitchCase="'credit_letter'">
            {{contractStep.auto_name}}
          </span>
          <span *ngSwitchDefault>
            {{'CONTRACTS.TEXT.STEPS_NAME2.' + contractStep.target_type | uppercase |translate}} {{contractStep.name||contractStep.auto_name}}
          </span>
        </span>
      </div>
      <div 
        class="step-preview-title-deadline" 
        [style.color]="stepsStylingMap.get(contractStep.target_type).stepDeadlineColor"
        *ngIf="contractStep.target_type==='sub_contract'">
        <mat-icon class="" svgIcon="time-line" style="width: 14px;"
          [color]="stepsStylingMap.get(contractStep.target_type).stepDeadlineColor"> 
        </mat-icon>
        <div class="step-preview-title-deadline-label" *ngIf="contractStep?.created_at">
          {{'CONTRACTS.CARD.created_at'| uppercase | translate }} {{' '}}
          {{contractStep.created_at | date:'dd.MM.yyyy'}}
          {{' '+('CONTRACTS.CARD.IN'| translate) +' '  }}
          {{contractStep?.created_at.split(' ')[1]?.split('.')[0]?.slice(0,5)}}
        </div>
      </div>

      <div class="step-preview-title-deadline active" 
        (click)="openCalendar()" 
        *ngIf="contractStep.target_type!=='sub_contract'">
        <mat-icon class="" svgIcon="time-line" style="width: 14px;"
          [color]="stepsStylingMap.get(contractStep.target_type).stepDeadlineColor"> 
        </mat-icon>
        <div 
          [style.color]="stepsStylingMap.get(contractStep.target_type).stepDeadlineColor"
          class="step-preview-title-deadline-label" 
          *ngIf="contractStep?.deadline_at">
          {{'CONTRACTS.CARD.DEADLINE_AT'| uppercase | translate }} {{' '}}
          {{( contractStep.deadline_at) | date:'dd.MM.yyyy'}}
          {{' '+('CONTRACTS.CARD.IN'| translate) +' 22:00'}}
        </div>
        <div class="step-preview-title-deadline-label" 
          *ngIf="!contractStep?.deadline_at"
          [style.color]="stepsStylingMap.get(contractStep.target_type).stepDeadlineColor"
          >
          {{'CONTRACTS.CARD.DEADLINE_AT'| uppercase | translate }} {{'  не установлен'}}
        </div>
      </div>

      <mat-calendar 
        *ngIf="showCalendar" 
        [(selected)]="contractStep.deadline_at" 
         [minDate]="minDate"
        (selectedChange)="deadlineDateChanged($event)">
      </mat-calendar>
      <input matInput [formControl]="timeFC" type="time" placeholder="Pick a time" *ngIf="showCalendar" class= "time-picker" >
      
      <div class="step-preview-desc" 
        [innerHTML]="contractStep?.description||'Новое описание'"
        (click)="openDescriptionEditor()"
        >
      </div>
    </div>
    
      <ng-container
        *ngComponentOutlet="StepComponentMap.get(contractStep.target_type).component; inputs: {
          contractStep:contractStep,
          contractData:contractData
          };"
      ></ng-container>
  </div>
</div>

